module.exports = __webpack_public_path__ + "static/media/card-decline.f69d3eca.png";